import axios from 'axios'

import { API_ROUTES, BASE_API_CONFIG } from '../../../shared/utils/api'

export default {
  DEFAULT_ORDER: 'desc',

  getAllVideoResourceArticles(optional_params = {}) {
    return axios.request({
      ...BASE_API_CONFIG,
      method: 'GET',
      url: API_ROUTES.video_resources_articles(optional_params.episode_id),
    })
  },

  getArticles() {
    return axios.request({
      ...BASE_API_CONFIG,
      method: 'GET',
      url: API_ROUTES.admin_articles,
    })
  },

  createVideoResourceArticles(article_id, optional_params = {}) {
    const data = {
      article_id: article_id,
    }

    return axios.request({
      ...BASE_API_CONFIG,
      method: 'POST',
      url: API_ROUTES.video_resources_articles(optional_params.episode_id),
      data,
    })
  },

  deleteVideoResourceArticle(article, optional_params = {}) {
    return axios.request({
      ...BASE_API_CONFIG,
      method: 'DELETE',
      url: API_ROUTES.video_resources_article(
        optional_params.episode_id,
        article.id
      ),
    })
  },
}
